import React, { useEffect, useState } from "react";
import { useUser } from "../../../../hooks/use-user";

function MainTimer({ startTimeON, endTimeON, contestId }) {
  const { data: user } = useUser();
  const [isEnd, setIsEnd] = useState("green");
  const [isEnd2, setIsEnd2] = useState("green");
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const start1 = new Date(startTimeON);
  const end1 = new Date();
  end1.setHours(endTimeON, 0, 0, 0);
  useEffect(() => {
    const interval = setInterval(() => {
      const timeData = calculateTimeLeft();
      setTimeLeft(timeData);

      if (timeData.message === "ends in") {
        setIsEnd("red");
      } else {
        setIsEnd("green");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const timeData = calculateTimeLeft();
    setIsEnd2(timeData.message);
    if (timeData.message === "ends in") {
      setIsEnd("red");
    } else {
      setIsEnd("green");
    }
  }, [timeLeft]);

  function calculateTimeLeft() {
    const now = new Date();
    const start = new Date(startTimeON);
    const end = new Date(endTimeON);
    // start.setHours(startTimeON, 0, 0, 0); // Set start time
    // end.setHours(endTimeON, 0, 0, 0); // Set end time
    // console.log(end)
    // console.log(now)
    if (now < start) {
      return { time: start - now, message: "starts in" };
    } else if (now >= start && now <= end) {
      return { time: end - now, message: "ends in" };
    } else {
      return { time: 0, message: "Offer Expired" };
    }
  }

  // console.log(startTimeON,typeof(startTimeON))
  // console.log(endTimeON)
  // console.log("---------------------")

  function formatTimeLeft(milliseconds) {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  }

  const time = formatTimeLeft(timeLeft.time);

  return (
    <div className="p-2 ml-2 mt-2 flex flex-col justify-center">
      <div className="flex flex-col mb-2">
        {isEnd2 === "starts in" ? (
          <p className="text-start font-oswald text-white font-bold">
            START IN
          </p>
        ) : isEnd2 === "ends in" ? (
          <p className="text-start font-oswald text-red font-bold">END IN</p>
        ) : null}
        <div className="flex text-start items-center gap-2">
          <div className="flex count-down-main">
            {timeLeft.time > 0 ? (
              <div className="flex">
                {time.days > 0 && (
                  <>
                    <div className="timer font-oswald">
                      <div className={`text-${isEnd} overflow-hidden`}>
                        <h3 className="countdown-element hours font-Cormorant font-semibold text-3xl text-white text-center">
                          {time.days}
                        </h3>
                      </div>
                    </div>
                    <h3 className="font-manrope font-semibold text-2xl text-white ml-2 mr-2">
                      :
                    </h3>
                  </>
                )}
                <div className="timer font-oswald">
                  <div className={`text-${isEnd} overflow-hidden`}>
                    <h3 className="countdown-element hours font-Cormorant font-semibold text-3xl text-white text-center">
                      {time.hours}
                    </h3>
                  </div>
                </div>
                <h3 className="font-manrope font-semibold text-2xl text-white ml-2">
                  :
                </h3>
                <div className="timer w-12 font-oswald">
                  <div className={`text-${isEnd} overflow-hidden`}>
                    <h3 className="countdown-element minutes font-Cormorant font-semibold text-3xl text-white text-center">
                      {time.minutes}
                    </h3>
                  </div>
                </div>
                {time.days === 0 && (
                  <>
                    <h3 className="font-manrope font-semibold text-2xl text-white">
                      :
                    </h3>
                    <div className="timer w-12 font-oswald">
                      <div className={`text-${isEnd} overflow-hidden`}>
                        <h3 className="countdown-element seconds font-Cormorant font-semibold text-3xl text-white text-center animate-countinsecond">
                          {time.seconds}
                        </h3>
                      </div>
                    </div>
                  </>
                )}
                <h1 className="text-start text-gray-400 font-bold text-lg">
                  Hrs
                </h1>
              </div>
            ) : (
              <div className="text-xl mt-4 font-bold font-cunia">
                {user?.joinedContests?.includes(contestId) ? (
                  <span className="text-green-400">CONTEST COMPLETED</span>
                ) : (
                  <span className="text-red">CONTEST EXPIRED</span>
                )}
              </div>
            )}
            {/* <div>
        <h1>
          {isEnd2}
        </h1>
      </div> */}
          </div>

          {/* <h1 className="text-start text-gray-400 font-bold text-lg">
                    Hrs
                  </h1> */}
        </div>
      </div>
    </div>
  );
}

export default MainTimer;
